import React from "react";

const Pagination = ({ prevPage, nextPage, fetchPage }) => {
  return (
    <div className="pagination-container">
      <button 
        className="btn btn-secondary pagination-btn" 
        onClick={() => fetchPage(prevPage)}
        disabled={!prevPage}
      >
        ◀ Anterior
      </button>

      <button 
        className="btn btn-primary pagination-btn" 
        onClick={() => fetchPage(nextPage)}
        disabled={!nextPage}
      >
        Siguiente ▶
      </button>
    </div>
  );
};

export default Pagination;
